import {
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { AuthStore } from './features/auth/store/auth.store';

export const appConfig:
  ApplicationConfig = {
    providers: [
      provideBrowserGlobalErrorListeners(),
      provideZonelessChangeDetection(),
      provideHttpClient(
        withInterceptors([
          authInterceptor,
        ]),
      ),
      provideRouter(routes),
      provideAppInitializer(
        () =>
          inject(
            AuthStore,
          ).restoreSession(),
      ),
    ],
  };
